import { Carousel } from 'bootstrap';

const initMuCarousel = () => {
   const carouselEl = document.getElementById('mu-home__carousel');
   if (!carouselEl) return () => {};

   const carouselInner = carouselEl.querySelector('.carousel-inner');
   if (!carouselInner) return () => {};

   const carousel = Carousel.getOrCreateInstance(carouselEl);

   // Smooth height transitions
   carouselEl.style.transition = 'height 0.3s ease';
   carouselInner.style.transition = 'height 0.3s ease';

   /**
    * Update carousel height based on the active slide only
    */
   const updateHeight = () => {
      const activeSlide = carouselEl.querySelector('.carousel-item.active');
      if (!activeSlide) return;

      if (window.innerWidth <= 991) {
         const activeHeight = activeSlide.getBoundingClientRect().height;
         carouselEl.style.height = `${activeHeight}px`;
         carouselInner.style.height = `${activeHeight}px`;
      } else {
         // Reset height for desktop/tablet to let CSS handle it
         carouselEl.style.height = '';
         carouselInner.style.height = '';
      }
   };

   // Efficient window resize handling
   let rafResize = null;
   const onResize = () => {
      if (rafResize) return;
      rafResize = requestAnimationFrame(() => {
         rafResize = null;
         updateHeight();
      });
   };
   window.addEventListener('resize', onResize);

   // Update height on slide change
   carouselEl.addEventListener('slid.bs.carousel', updateHeight);

   // Next/prev button handling
   const navButtons = carouselEl.querySelectorAll(
      '.carousel-control-prev, .carousel-control-next'
   );
   const handleNavClick = () => updateHeight();
   navButtons.forEach((btn) => btn.addEventListener('click', handleNavClick));

   // --- ResizeObserver for dynamic slide content ---
   let resizeObserver = null;
   const observeActiveSlide = () => {
      // Disconnect previous observer if any
      if (resizeObserver) resizeObserver.disconnect();

      const activeSlide = carouselEl.querySelector('.carousel-item.active');
      if (!activeSlide) return;

      // Observe changes in the active slide's content
      resizeObserver = new ResizeObserver(() => {
         updateHeight();
      });
      resizeObserver.observe(activeSlide);
   };

   // Observe whenever slides change
   carouselEl.addEventListener('slid.bs.carousel', observeActiveSlide);

   // Initial height adjustment and observer
   updateHeight();
   observeActiveSlide();

   // Cleanup function
   return () => {
      window.removeEventListener('resize', onResize);
      carouselEl.removeEventListener('slid.bs.carousel', updateHeight);
      carouselEl.removeEventListener('slid.bs.carousel', observeActiveSlide);
      navButtons.forEach((btn) => btn.removeEventListener('click', handleNavClick));
      if (resizeObserver) resizeObserver.disconnect();
   };
};

export default initMuCarousel;
